<script>
  import { onMount } from 'svelte';

	export let codeValue;
	export let squareSize;
  export let elementID
  export let colorLight = "#ffffff"

  let qrcode;

	onMount(() => {

		let script = document.createElement('script');
    script.src = "https://cdn.rawgit.com/davidshimjs/qrcodejs/gh-pages/qrcode.min.js"
    document.head.append(script);

		script.onload = function() {

			qrcode = new QRCode(elementID, {
				text: codeValue,
		  	width: squareSize,
        height: squareSize,
        //colorDark : "#000000",
        colorDark : "#255991",
        // colorLight : "#ffffff",
        colorLight : colorLight,
        correctLevel : QRCode.CorrectLevel.H
			});

		};

	});
</script>

<style>
  #qrcode {
    width:20px;
    height:200x;
    margin-top:15px;
    cursor: -webkit-zoom-in;
    cursor: zoom-in;
  }
</style>

<div id="{elementID}"></div>
